module.exports = __webpack_public_path__ + "img/DirectionsBikeOutlined.5375bc06.svg";